var render, staticRenderFns
import script from "./PostList.vue?vue&type=script&lang=tsx&"
export * from "./PostList.vue?vue&type=script&lang=tsx&"
import style0 from "./PostList.vue?vue&type=style&index=0&id=0de75e75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de75e75",
  null
  
)

export default component.exports